import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'audiences'
const verb = 'get'

export default class OspreyAudienceSearch extends BaseAction {
    constructor(dataKey) {
        const id = 'bd1587fb-fc46-4b30-b3c1-366c4e95c4ca'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    search(params) {
        this.params = Object.assign({
            fields: 'id,name,description,channels,tags'
        }, params)

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/audiences/audience-search.js